import { UndergraduatePortal } from '../../../shared/templates/portal/undergraduate'
import { ToastContainer } from 'react-toastify'
import VotingPage from './voting-page'
import { useLocation } from 'react-router-dom'


const ElectionMenu = () => {

  const location = useLocation();
    const { electionType } = location.state || {};

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        style={{ marginTop: "20px" }}
      />
      <UndergraduatePortal
        title= {`${electionType} ELECTION`}
        childComponent={<VotingPage
           electionType= {electionType}
           />}
      />
    </>
  )
}

export default ElectionMenu
